module.exports = __webpack_public_path__ + "static/media/icono-ufs-uy-pesos.91da83ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-ufs-uy-pesos.png
// module id = 295
// module chunks = 0